import React from "react";

export default function IndentIcon(props) {
  return (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512;"
      style={{ height: "20rem", width: "20rem" }}
    >
      <path
        fill={props.color}
        d="M501.333,106.667H10.667C4.776,106.667,0,101.891,0,96c0-5.891,4.776-10.667,10.667-10.667h490.667
        C507.224,85.333,512,90.109,512,96C512,101.891,507.224,106.667,501.333,106.667z"
      />
      <path
        fill={props.color}
        d="M352,170.667H138.667c-5.891,0-10.667-4.776-10.667-10.667s4.776-10.667,10.667-10.667H352
        c5.891,0,10.667,4.776,10.667,10.667S357.891,170.667,352,170.667z"
      />
      <path
        fill={props.color}
        d="M501.333,234.667H138.667c-5.891,0-10.667-4.776-10.667-10.667s4.776-10.667,10.667-10.667h362.667
        c5.891,0,10.667,4.776,10.667,10.667S507.224,234.667,501.333,234.667z"
      />
      <path
        fill={props.color}
        d="M352,298.667H138.667c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667H352
        c5.891,0,10.667,4.776,10.667,10.667C362.667,293.891,357.891,298.667,352,298.667z"
      />
      <path
        fill={props.color}
        d="M501.333,362.667H138.667c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667
        h362.667c5.891,0,10.667,4.776,10.667,10.667C512,357.891,507.224,362.667,501.333,362.667z"
      />
      <path
        fill={props.color}
        d="M352,426.667H10.667C4.776,426.667,0,421.891,0,416c0-5.891,4.776-10.667,10.667-10.667H352
        c5.891,0,10.667,4.776,10.667,10.667C362.667,421.891,357.891,426.667,352,426.667z"
      />
      <path
        fill={props.color}
        d="M103.552,237.781l-85.333-85.333c-4.16-4.171-10.914-4.179-15.085-0.019
        C1.123,154.435-0.005,157.16,0,160v170.667c0.001,4.316,2.603,8.207,6.592,9.856c1.291,0.538,2.676,0.813,4.075,0.811
        c2.831,0.005,5.548-1.115,7.552-3.115l85.333-85.333c4.171-4.16,4.179-10.914,0.019-15.085
        C103.565,237.794,103.558,237.788,103.552,237.781z"
      />
    </svg>
  );
}
